export default "__VITE_ASSET__B7NUZV_b__"